import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  BffConnectionsQuerySchema,
  BffConnectionsResponseDataSchema,
  ConnectionQuerySchema,
  ConnectionSchema,
  ConnectionSchemaV2,
  ConnectionsResponseDataSchema,
  ConnectionsResponseDataSchemaV2,
  UpdateConnectionRequestSchema,
  VerifyConnectionResponseSchema,
} from '../shared/schemas/ConnectionSchema.js';

export const getConnectionList = defaultClient.query({
  url: 'omni-connector-service/connection/list' as const,
  method: 'GET',
  responseSchema: ConnectionsResponseDataSchema,
  querySchema: ConnectionQuerySchema,
  processResponse(data) {
    return data?.data?.items;
  },
});

export const getBffConnectionList = defaultClient.query({
  url: 'bff/v1/connections/' as const,
  method: 'GET',
  responseSchema: BffConnectionsResponseDataSchema,
  querySchema: BffConnectionsQuerySchema,
  processResponse(data) {
    return data?.data?.items;
  },
});

export const getConnectionListV2 = defaultClient.query({
  url: 'bff/v2/connections/' as const,
  method: 'GET',
  responseSchema: ConnectionsResponseDataSchemaV2,
  querySchema: z.object({
    cache: z.string(),
  }),
  processResponse(data) {
    return data;
  },
});

export const deleteConnection = defaultClient.mutation({
  url: 'omni-connector-service/connection/$connectionId' as const,
  method: 'DELETE',
  responseSchema: z.string(),
  processResponse: (data) => data,
  onSuccess: (queryClient) => {
    getBffConnectionList.invalidateAll(queryClient, {});
    getConnectionList.invalidateAll(queryClient, {});
  },
});

export const update = defaultClient.mutation({
  url: 'omni-connector-service/connection/$connectionId/update' as const,
  method: 'PATCH',
  responseSchema: ConnectionsResponseDataSchema,
  requestSchema: UpdateConnectionRequestSchema,
  processResponse: (data) => data,
  onSuccess: (queryClient) => {
    getBffConnectionList.invalidateAll(queryClient, {});
    getConnectionList.invalidateAll(queryClient, {});
  },
});

export const verify = defaultClient.query({
  url: 'omni-connector-service/connection/verify/$connectionId' as const,
  method: 'GET',
  responseSchema: VerifyConnectionResponseSchema,
  querySchema: ConnectionQuerySchema,
  processResponse(data) {
    return data?.data?.items[0]?.verified;
  },
});

export type ConnectionType = z.infer<typeof ConnectionSchema>;
export type ConnectionTypeV2 = z.infer<typeof ConnectionSchemaV2>;
